import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const values = [['S.O.S. Lactancia — 6 tomos', '$89.000'], ['6 bonos prácticos incluidos', '$71.000']];
export function ValueSummary() {
  return <section className="bg-brand-cream px-4 py-16 md:py-20" data-id="element-328" data-mp="bz1gugu2bol0">
      <div className="mx-auto max-w-3xl" data-id="element-329" data-mp="gw054ir1p1ba">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-3xl border border-brand-primary/35 bg-brand-cream-light p-7 shadow-xl md:p-10" data-id="element-330" data-mp="gwt7z8mvv6o5">
          <div className="text-center" data-id="element-331" data-mp="vm7gkeimxk2h">
            <p className="text-sm font-bold tracking-[0.14em] text-brand-accent uppercase" data-id="element-332" data-mp="vl62e16bohgj">Un pack, todo el acompañamiento</p>
            <h2 className="mt-3 font-serif text-4xl text-brand-darker md:text-5xl" data-id="element-333" data-mp="3gbojb1v1i4l1">Mirá todo lo que te llevás</h2>
          </div>

          <div className="mt-8 divide-y divide-brand-primary/25 border-y border-brand-primary/25" data-id="element-334" data-mp="3kdidcraqcac8">
            {values.map(([label, value]) => <div key={label} className="flex items-center justify-between gap-4 py-4 text-brand-darker" data-id="element-335" data-mp="1vdbevfevopv0">
                <span data-id="element-336" data-mp="1qegysl8apfel">{label}</span>
                <span className="font-medium text-brand-darker/55 line-through" data-id="element-337" data-mp="24c5ivqujgiil">{value}</span>
              </div>)}
          </div>

          <div className="mt-6 rounded-2xl bg-[#fff8e7] p-5 text-center" data-id="element-338" data-mp="2090hxsq3wow2">
            <p className="text-sm font-bold text-brand-darker" data-id="element-339" data-mp="2e8s2kcb4p3j1">VALOR INDIVIDUAL: <span className="line-through" data-id="element-340" data-mp="29bi4675rhhj2">$160.000 ARS</span></p>
            <p className="mt-2 font-serif text-4xl font-bold text-brand-darker" data-id="element-341" data-mp="298vx08ms941d">HOY: $19.990 ARS</p>
            <p className="mt-2 text-sm text-brand-darker/70" data-id="element-342" data-mp="2o1z7jw1yihil">6 tomos + 6 bonos · Oferta válida desde esta página.</p>
          </div>
        </motion.div>
        <CTAButton label="✨ QUIERO MI PACK DE LACTANCIA ✨" tone="light" data-id="element-343" data-mp="2x1m70cb4ld90" />
      </div>
    </section>;
}